// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/captcha/mobile_captcha.proto" (package "base.captcha", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MobileCaptchaService } from "./mobile_captcha";
import type { CheckResponse } from "./mobile_captcha";
import type { CheckRequest } from "./mobile_captcha";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GenerateResponse } from "./mobile_captcha";
import type { GenerateRequest } from "./mobile_captcha";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service base.captcha.MobileCaptchaService
 */
export interface IMobileCaptchaServiceClient {
    /**
     * @generated from protobuf rpc: Generate
     */
    generate(input: GenerateRequest, options?: RpcOptions): UnaryCall<GenerateRequest, GenerateResponse>;
    /**
     * @generated from protobuf rpc: Check
     */
    check(input: CheckRequest, options?: RpcOptions): UnaryCall<CheckRequest, CheckResponse>;
}
/**
 * @generated from protobuf service base.captcha.MobileCaptchaService
 */
export class MobileCaptchaServiceClient implements IMobileCaptchaServiceClient, ServiceInfo {
    typeName = MobileCaptchaService.typeName;
    methods = MobileCaptchaService.methods;
    options = MobileCaptchaService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Generate
     */
    generate(input: GenerateRequest, options?: RpcOptions): UnaryCall<GenerateRequest, GenerateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateRequest, GenerateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Check
     */
    check(input: CheckRequest, options?: RpcOptions): UnaryCall<CheckRequest, CheckResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckRequest, CheckResponse>("unary", this._transport, method, opt, input);
    }
}
